module.exports = __webpack_public_path__ + "media/images/mineco-0c29e6d2b0a33597115769b136797414.png";